import { render, staticRenderFns } from "./exam-list.vue?vue&type=template&id=db8b7ace&scoped=true"
import script from "./exam-list.vue?vue&type=script&lang=ts"
export * from "./exam-list.vue?vue&type=script&lang=ts"
import style0 from "./exam-list.vue?vue&type=style&index=0&id=db8b7ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8b7ace",
  null
  
)

export default component.exports